<template>
	<div class="index">
			<div class="djxxDetail_wrap">
			      <!-- 上方新闻信息 -->
				  <div class="top_content">
                    <div class="left_pic">
                        <img style="width: 100%;height: 100%;" :src="detailDate.img" alt="">
                    </div>
                    <div class="right_content_zzsh">
                         <div class="right_content_top">
                            <div class="right_content_top_left">
                                {{ detailDate.title }}
                            </div>
                         
                         </div>
						 <div class="right_content_top_right_box">
                          </div>	
                          <!-- 下方课程信息 -->
                          <div class="dataList_item_bottom_botom_zzsh">
                              <div class="dataList_item_bottom_botom_zzsh_item">
								 <div class="zzsh_left">发布组织：<span style="font-weight: 800;">{{detailDate.pub_user}}</span>
								</div>
							  </div>
							  <div class="dataList_item_bottom_botom_zzsh_item">
								 <div class="zzsh_left">活动类型：<span style="font-weight: 800;">{{detailDate.sync_label}}</span>
								</div>
								 <div class="zzsh_left">活动时间：<span >{{$changeTime(detailDate.h_stime)}}</span>
								</div>
								
							  </div>
							  <div class="dataList_item_bottom_botom_zzsh_item">
								 <div class="zzsh_left">活动标签：<span style="font-weight: 800;">{{detailDate.sync_label}}</span>
								</div>
								<div class="zzsh_left">活动地址：<span>{{detailDate.address}}</span>
								</div>
							  </div>
							  
							  
                         </div>
                    </div>
                 </div>
                 <!-- 下方课程列表 -->
                 <div class="bottom_List">
                     <!-- 学习资料列表 -->
                     <div v-if="resouceList.length>0" class="bottom_List_title" style="margin-top: 20px;margin-bottom: 20px;">
                         <div class="bottom_List_title_center">学习资料</div>
						 <div class="right_back">
							<div class="right_back_icon"><img src="../../assets/xiangning/news_detail/back.png" alt=""></div>
							<div @click="$router.go(-1)" >返回</div>
						</div>
                     </div>
					 <!-- 学习资料列表 -->
					 <div class="shyk_study">
                        <div class="shyk_study_item" v-for="item in resouceList" :key="item.id">
                              <div class="shyk_study_item_top_img">
                                    <img :src="item.sz_img" alt="">
							  </div>
							  <div class="shyk_study_item_bottom">
                                 <div class="shyk_study_item_bottom_title">
									{{ item.title }}
								 </div>
								 <div class="shyk_study_item_bottom_click">
									 <div class="shyk_study_item_bottom_click_left">
                                          <!-- <img src="../../assets/xiangning/zzsh/zzsh_down.png" alt="">
										  <span>下载</span> -->
									 </div>
									 <div @click="goZzshDetail(item)" class="shyk_study_item_bottom_click_right">
										 立即学习
									</div>
								 </div>
							  </div>
						</div>
					 </div>
                 </div>
			 </div>
	     </div>
</template>
<script>
	import Swiper from 'swiper';
	import { zzsh } from '@/axios';
	import Page from '@/components/page.vue'
	export default{
		data(){
			return{
			
			// 当前页码
			per_page:1,
			index:0,
			input:'',
			type:'pdf',
			detailDate:{},
			userList:[],
			resouceList:[],
			centerDialogVisible:false,
			centerDialogVisible2:false,
			code:'',
			code2:'',
			// 扫码筛选
			selectCode:1,
			signed:[],
			// 学习新得添加
			addRecordDate:{
					tid:this.$route.query.id,
					
				
					content:""
			},
			sunCodeData:{
				hyid:'',
				hyflag:'',
				s_time:''
			}
		
			}
			
		},
		components:{ Page },
		methods:{
		    // 扫码签到
			sunCode(){
               this.centerDialogVisible2=true
			   //发起请求获取会议二维码
                let that=this
				zzsh.getWxcode(that.sunCodeData).then(res=>{
					that.code=res.data
				})
				zzsh.getAppCode(that.sunCodeData).then(res=>{
					
					that.code2=res.data
				})


			},
			dialogClose(){
				// 签到对话框关闭
				 let that=this
				 zzsh.signLog({hyid:that.detailDate.id,hy_flag:that.detailDate.hy_flag}).then(res=>{
					that.signed=res.log
				 })
			},
			// 获取组织生活详情
			getZzshDetail(){
              let that=this
			  zzsh.shykDetail({hyid:that.$route.query.id,hyflag:this.$route.query.flag}).then(res=>{
				if (res.code==200) {
					that.detailDate=res.data
					that.resouceList=res.data.files
					that.sunCodeData.hyid=res.data.id
					that.sunCodeData.hyflag=res.data.hy_flag
					that.sunCodeData.s_time=res.data.h_stime
					// that.dialogClose()
				}
			  })
			},
			// 资源播放
			goZzshDetail(data){
				let that=this
                  this.$router.push({
					path:'/roucePlay',
					query:{
						id:that.$route.query.id,
						flag:that.$route.query.flag,
						zyid:data.rid,
						bsid:data.bs_id,
						type:'shyk'

						
					}
				  })
			},
			// 学习心得提交
			submitRecord(){
				
				let that=this
				// 向服务器提交汇报记录
				zzsh.addRecord(that.addRecordDate).then((res)=>{
					if (res.code==200) {
						Message({
								type:"success",
								message:"提交成功"
							})
							this.centerDialogVisible=false
					}
				})
				
			},
		  },
		mounted(){
	      this.getZzshDetail()
		},
		created() {
			this.$emit("highLight",9,"","","");
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	  
		
	.index{
		width: 100%;
		div{
			box-sizing: border-box;
		}
		.djxxDetail_wrap{
			width: $indexWidth;
			margin: auto;
			min-width: 1200px;
			position: relative;
			margin-top: 20px;
		    //上方课程信息
			.top_content{
				height: 242px;
				width: 100%;
				margin-bottom: 20px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				.left_pic{
					width: 384px;
					height: 242px;
					border-radius: 8px;
					overflow: hidden;
					img{
						width: 100%;
						height: 100%;
					}

				}
				.right_content_zzsh{
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					// height: 182px;
					width: 792px;
					.right_content_top{
					height: 32px;
					width: 100%;
					/* background-color: pink; */
					display: flex;
					justify-content: space-between;
						.right_content_top_left{
							width: 512px;
							height: 100%;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							font-family: PingFangSC-Medium;
							font-size: 24px;
							font-weight: 800;
							letter-spacing: 0px;
							color: #000000;

						}
						
					}
					.right_content_center{
					width: 100%;
					height: 62px;
					overflow: hidden;
					text-overflow: ellipsis;
					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					line-height: 20px;
					text-align: justify; /* 浏览器可能不支持 */
					letter-spacing: 0px;
					color: #666666;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp:3 ;
				    }
					.right_content_top_right_box{
						width: 100%;
						display: flex;
						justify-content: start;
						margin-top: 20px;
						margin-bottom: 20px;
						.right_content_top_right{
							max-width: 730px;
							height: 32px;
							font-family: PingFangSC-Regular;
							font-size: 16px;
							font-weight: normal;
							letter-spacing: 0em;
							color: #FFFFFF;
							padding: 5px 17px;
							background-color: #C9010A;
							border-radius: 261px;
							white-space: nowrap;
							text-overflow: ellipsis;
							overflow: hidden;
							margin-right: 20px;
						}
					}
					
					.dataList_item_bottom_botom_zzsh{
						width: 100%;
						font-family: PingFangSC-Regular;
						font-size: 14px;
						font-weight: normal;
						line-height: normal;
						letter-spacing: 0em;
						.dataList_item_bottom_botom_zzsh_item{
							margin-top: 16px;
							height: 20px;
							display: flex;
							justify-content: space-between;
						}
					   
					}
				}
			}
			/* 下方课程列表 */
			.bottom_List_title{
				width: 100%;
				height: 40px;
				box-sizing: border-box;
				padding-left: 6px;
				background: #F7F7F7;
				display: flex;
				align-items: center;
				.bottom_List_title_center{
					width: 100%;
					height: 22px;
					box-sizing: border-box;
					border-left: 4px solid #C9010A;
					padding-left: 10px;
					font-family: PingFangSC-Medium;
					font-size: 16px;
					font-weight: 800;
					letter-spacing: 0.1em;
					color: #000000;
                
				}
				.right_back{
				width: 50px;
				display: flex;
				font-family: PingFangSC-Regular;
				font-size: 12px;
				font-weight: normal;
				letter-spacing: 0em;
				color: #666666;
				margin-right: 10px;
				}
				.right_back:hover{
					font-weight: 800;
					color: #EE632B;
				}
				.right_back_icon{
					height: 10px;
					width: 12px;
					margin-right: 5px;
				}
				.right_back_icon img{
					height: 100%;
					width: 100%;
				}
			}
			
			.shyk_study{
				width: 100%;
				
				display: flex;
				justify-content: start;
				.shyk_study_item{
					border: 1px solid #ECEEF4;
					border-radius: 4px;
					width: 224px;
					height:200px;
					margin-right: 20px;
					margin-bottom: 40px;
					.shyk_study_item_top_img{
						width: 100%;
						height: 126px;
						img{
							width: 100%;
							height: 100%;
						}
					}
					.shyk_study_item_bottom{
						box-sizing: border-box;
						padding: 10px;
						.shyk_study_item_bottom_title{
						width: 100%;
						height: 20px;
						line-height: 20px;
						font-family: PingFangSC-Medium;
						font-size: 14px;
						font-weight: 800;
						letter-spacing: 0em;
						color: #000000;
						text-overflow: ellipsis;
						overflow: hidden;
						white-space: nowrap;
						margin-bottom: 7px;
					    }
						.shyk_study_item_bottom_click{
							width: 100%;
							height: 24px;
							display: flex;
							justify-content: space-between;
							align-items: center;
							.shyk_study_item_bottom_click_left{
								font-family: PingFangSC-Regular;
								font-size: 12px;
								font-weight: normal;
								line-height: normal;
								letter-spacing: 0px;
								color: #B53636;
								line-height: 24px;
								display: flex;
							    cursor: pointer;
								align-items: center;
								img{
									margin-right: 10px;
								}
							}
							.shyk_study_item_bottom_click_left:hover{
								font-weight: 800;
							}
							.shyk_study_item_bottom_click_right{
								cursor: pointer;
								box-sizing: border-box;
								padding: 0 16px;
								width: 80px;
								height: 24px;
								line-height: 24px;
								border-radius: 206px;
								opacity: 1;

								background: #B53636;
								color: #FFFFFF;
								font-family: PingFangSC-Regular;
								font-size: 12px;
							}
						}
					}
					
				}
				.shyk_study_item:nth-child(5n){
					margin-right: 0;
				}
			   }
			
		}
	}
		
			
</style>
